var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "128px",
    height: "128px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#1b49ea",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(2,2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5,9c-7.2,0 -13,5.8 -13,13v80c0,7.2 5.8,13 13,13h61c7.2,0 13,-5.8 13,-13v-80c0,-7.2 -5.8,-13 -13,-13zM33.5,15h61c3.9,0 7,3.1 7,7v80c0,3.9 -3.1,7 -7,7h-61c-3.9,0 -7,-3.1 -7,-7v-80c0,-3.9 3.1,-7 7,-7zM33.5,22v15h61v-15zM37.5,51c-1.7,0 -3,1.3 -3,3c0,1.7 1.3,3 3,3h51c1.7,0 3,-1.3 3,-3c0,-1.7 -1.3,-3 -3,-3zM37.5,66c-1.7,0 -3,1.3 -3,3c0,1.7 1.3,3 3,3h51c1.7,0 3,-1.3 3,-3c0,-1.7 -1.3,-3 -3,-3zM37.5,81c-1.7,0 -3,1.3 -3,3c0,1.7 1.3,3 3,3h26.5c1.7,0 3,-1.3 3,-3c0,-1.7 -1.3,-3 -3,-3z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconBlue);
export default __webpack_public_path__ + "static/media/file_icon_blue.343275485393be44a164fd20d8d00638.svg";
export { ForwardRef as ReactComponent };